// extracted by mini-css-extract-plugin
export default {"floatingDetails":"style_floatingDetails__Rsdev","success":"style_success__LwwYV","danger":"style_danger__awE7Q"};